/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from "react"
import {
    Modal,
    Row,
    ModalTitle,
    TitleSection,
    ContentSection,
    Button,
    Icon,
} from "trux"

export const SharePlayerModal = ({
    currentPlaylist,
    gameDate,
    isFullGame,
    fullGameEventNumber,
    fullGameTime,
    teamName,
    gameId,
    player,
    mode,
    extras,
    toast,
    history,
    location,
}) => {
    let open = extras.share ? true : false

    let backLink = history.location.pathname.replace("/share", "")

    let video = document.getElementById("video")
    if (video && open) {
        let pauseEvent = new CustomEvent("trc-pause")
        document.dispatchEvent(pauseEvent)
    }

    const onClose = () => {
        history.push(backLink)
        let playEvent = new CustomEvent("trc-play")
        document.dispatchEvent(playEvent)
    }

    let shareLink = window.location.href.replace("/share", "")
    shareLink += "?mtm_campaign=gp"
    shareLink += "&mtm_kwd=copy"

    let emailShareLink = window.location.href.replace("/share", "")
    emailShareLink += "?mtm_source=gp"
    emailShareLink += "&mtm_kwd=email"

    return (
        <Modal open={open} onShadeClick={onClose}>
            <TitleSection onCloseClick={onClose}>
                <ModalTitle content="Sharing" />
            </TitleSection>
            <ContentSection>
                <Row
                    start
                    spacingTop="5"
                    spacingBottom="5"
                    spacingLeft="4"
                    spacingRight="4"
                >
                    <Button
                        span="1"
                        trkAction="Copy Link Pressed"
                        onClick={(e) => {
                            copy(e, toast)
                            history.push(backLink)
                        }}
                        icon={Icon.Type.Link}
                        content="Copy link"
                        marginRight="3"
                    />
                    <textarea
                        readOnly
                        id="copy-link"
                        style={{
                            height: "1px",
                            width: "1px",
                            position: "absolute",
                            top: "-999px",
                            left: "-999px",
                        }}
                        value={shareLink}
                    />
                    <Button
                        span="1"
                        trkAction="Email Pressed"
                        href={playerEmailLink(emailShareLink, player, gameDate)}
                        target="_blank"
                        rel="noopener noreferer"
                        onClick={() => history.push(backLink)}
                        icon={Icon.Type.Email}
                        content="Email"
                    />
                </Row>
            </ContentSection>
        </Modal>
    )
}

function playerEmailLink(url, player, gameDate) {
    var subject = `${player.first_name} ${player.last_name}'s Video and Stats`

    var body = `Check out ${player.first_name} ${player.last_name}'s Video and Stats from ${gameDate}\n`
    body += "\n"
    body += url
    body += "\n"
    body += "\n"
    body += "Created by TRACE\n"
    body += "Soccer Artificial Intelligence\n"
    body += "\n"
    body += "\n"
    var encBody = encodeURIComponent(body)

    return `mailto:?BCC=sharingiscaring@traceup.com&Subject=${subject}&Body=${encBody}`
}

function copy(e, toast) {
    e.preventDefault()
    var el = document.getElementById("copy-link")
    el.contentEditable = true
    el.readOnly = true

    var range = document.createRange()
    range.selectNodeContents(el)
    var sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range) // Does not work for Firefox if a textarea or input
    if (el.nodeName === "TEXTAREA" || el.nodeName === "INPUT") {
        el.select() // Firefox will only select a form element with select()
    }
    if (
        el.setSelectionRange &&
        navigator.userAgent.match(/ipad|ipod|iphone/i)
    ) {
        el.setSelectionRange(0, 999999) // iOS only selects "form" elements with SelectionRange
    }

    try {
        document.execCommand("copy") // Security exception may be thrown by some browsers.
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex)
    }
    console.log("toast", toast)
    toast("Copied")
}
